import { Schema } from 'prosemirror-model'

// ProseMirror schema for rendering chat messages (read-only).
// Each message is a `message` node with a `role` attribute.
// Content is parsed as simple markdown-like text.

export const chatSchema = new Schema({
  nodes: {
    doc: { content: 'message+' },

    message: {
      attrs: {
        role: { default: 'user' },
        sequence: { default: 0 },
        timestamp: { default: null },
      },
      content: 'block+',
      toDOM(node) {
        return ['div', {
          class: `chat-message chat-role-${node.attrs.role}`,
          'data-role': node.attrs.role,
          'data-sequence': node.attrs.sequence,
        }, 0]
      },
    },

    paragraph: {
      content: 'inline*',
      group: 'block',
      toDOM() { return ['p', 0] },
    },

    code_block: {
      content: 'text*',
      group: 'block',
      code: true,
      marks: '',
      toDOM() { return ['pre', ['code', 0]] },
    },

    bullet_list: {
      content: 'list_item+',
      group: 'block',
      toDOM() { return ['ul', 0] },
    },

    ordered_list: {
      content: 'list_item+',
      group: 'block',
      attrs: { start: { default: 1 } },
      toDOM(node) {
        return ['ol', { start: node.attrs.start === 1 ? undefined : node.attrs.start }, 0]
      },
    },

    list_item: {
      content: 'paragraph block*',
      toDOM() { return ['li', 0] },
    },

    hard_break: {
      inline: true,
      group: 'inline',
      selectable: false,
      toDOM() { return ['br'] },
    },

    text: { group: 'inline' },
  },

  marks: {
    bold: {
      toDOM() { return ['strong', 0] },
    },
    italic: {
      toDOM() { return ['em', 0] },
    },
    code: {
      toDOM() { return ['code', 0] },
    },
    link: {
      attrs: { href: {}, title: { default: null } },
      toDOM(mark) {
        let href = mark.attrs.href
        try {
          const url = new URL(href, 'https://placeholder.invalid')
          if (!['http:', 'https:', 'mailto:'].includes(url.protocol)) href = '#'
        } catch { href = '#' }
        return ['a', {
          href,
          title: mark.attrs.title,
          target: '_blank',
          rel: 'noopener noreferrer',
        }, 0]
      },
    },
  },
})
